// eslint-disable-next-line
export enum CONFIGURATION_KEY {
    MIS_TAREAS_FTS = 'mis_tareas_fts' // eslint-disable-line
}

export interface ConfigurationItem {
    key: string
    value: string
}

export class ConfigurationResponse {
    configuration: ConfigurationItem[]
}
